app.directive('matchHeightOf', function($window, debounce, $log) {
   return {
       restrict: 'A',
       link: function($scope, $element, $attrs) {
           var nodeToObserve = angular.element($attrs.matchHeightOf)[0];

           var cssProperty = $attrs.matchHeightSetProperty || 'height';

           if(!nodeToObserve) {
               return;
           }

           var setHeightOfTarget = function() {
               var height = nodeToObserve.offsetHeight;
               $element.css(cssProperty, height + 'px');
           };

           addResizeListener(nodeToObserve, setHeightOfTarget);

           $scope.$on('$destroy', function() {
               removeResizeListener(nodeToObserve, setHeightOfTarget);
           });

           // First Execution
           setHeightOfTarget();
       }
   };
});